import "./outlet.css";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAdmins } from "../../redux/apiCalls";
import moment from "moment";
import PageHeader from "../../components/pageHeader/PageHeader";
import Table from "../../components/advancedTable";

export default function Outlet() {
    const dispatch = useDispatch();
    const products = useSelector((state) => state.user.products);
    const [filterCategory] = useState(undefined);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            const res = await getAdmins(dispatch, filterCategory);
            if (res) {
                setIsLoaded(true);
            }
        };
        fetchData();
    }, [dispatch, filterCategory]);

    const columns = [
        {
            accessor: "debtorCode",
            Header: "Debtor Code",
            width: 200,
            sortable: false,
            Cell: ({ value }) => (
                <div className="">{value ? value : ""}</div>
            ),
        },
        {
            accessor: "name",
            Header: "Name",
            width: 200,
            sortable: false,
        },
        {
            accessor: "phoneNumber",
            Header: "Phone Number",
            width: 300,
            sortable: false,
        },
        {
            accessor: "email",
            Header: "Email",
            width: 300,
            sortable: false,
            Cell: ({ value }) => (
                <div className="">{value ? value : ""}</div>
            ),
        },
        {
            accessor: "type",
            Header: "Type",
            width: 150,
            sortable: false,
            Cell: ({ value }) => (
                <div className="capitalize">
                    {value}
                </div>
            ),
        },
        {
            accessor: "status",
            Header: "Status",
            width: 200,
            sortable: false,
            Cell: ({ value }) => (
                <div className="capitalize">{value}</div>
            ),
        },
        {
            accessor: "createdAt",
            Header: "Member Since",
            width: 200,
            sortable: false,
            Cell: ({ value }) => (
                <div className="capitalize">
                    {moment(value).format("DD/MM/YYYY")}
                </div>
            ),
        },
    ];

    return (
        <div className="productList">
            <PageHeader 
                title="Outlets" 
                description="Manage and view all outlet information including contact details, status, and membership information."
            />
            {isLoaded === true && (
                <Table
                    data={products}
                    columns={columns}
                    pageCount={Math.ceil(products.length / 20)}
                    totalCount={products.length}
                    updatePagination={() => {}}
                    paginationState={{ page: 1, limit: 20 }}
                    updateLoaded={() => {}}
                    hidePagination={false}
                />
            )}
        </div>
    );
}
